import { neutral, success as _success, error as _error, brand, } from '../global';
export const brandBorder = {
    primary: brand[600],
    secondary: brand[600],
    success: _success[500],
    error: _error[500],
    ctaTertiary: neutral[100],
    input: brand[800],
    inputChecked: neutral[100],
    inputHover: neutral[100],
};
//# sourceMappingURL=brand.js.map
